import { openingAct } from './acts/01-opening';
import { understandsYouAct } from './acts/02-understands-you';
import { networkedSelfAct } from './acts/03-networked-self';
import { amplifiedSelfAct } from './acts/04-amplified-self';

export { type DemoTourStep } from './types';

export const demoTourSteps = [
  ...openingAct,
  ...understandsYouAct,
  ...networkedSelfAct,
  ...amplifiedSelfAct,
];
